import { render, staticRenderFns } from "./PcAdvisorContextTabs.vue?vue&type=template&id=3f0cf984&scoped=true"
import script from "./PcAdvisorContextTabs.vue?vue&type=script&lang=js"
export * from "./PcAdvisorContextTabs.vue?vue&type=script&lang=js"
import style0 from "./PcAdvisorContextTabs.vue?vue&type=style&index=0&id=3f0cf984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0cf984",
  null
  
)

export default component.exports